import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { setTTFFStart } from '../../actions/videoPlayer';

export type OpenModalProps = {
    videoId: string;
    videoUrl: string;
    position?: number;
    extraQuery?: {
        [id: string]: string | number;
    };
    children: (handleOnClick: () => void) => React.ReactNode;
};

const OpenModal: React.FC<OpenModalProps> = ({ videoId, videoUrl, position, extraQuery, children }) => {
    const query = { modalId: videoId } as any;
    const visibleId = { id: videoId } as any;
    const router = useRouter();
    const dispatch = useDispatch();
    let visiblePosition;

    if (position) {
        query.position = position;
        visiblePosition = { position: position };
    }

    if (!router.query.modalId) {
        query.delayUnmount = true;
    }

    const handleOnClick = () => {
        dispatch(setTTFFStart(Date.now()));
    };

    let href = {
        query: { ...query, ...extraQuery },
    } as any;

    if (videoUrl?.startsWith('/klipp')) {
        href.pathname = '/klipp/[videoId]/[titleSlug]';
    } else if (videoUrl?.startsWith('/video')) {
        href.pathname = '/video/[videoId]/[...slug]';
    }

    return (
        <Link
            href={href}
            as={{
                pathname: videoUrl,
                query: { ...visibleId, ...visiblePosition, ...extraQuery },
            }}
            scroll={false}
            passHref
            replace={Boolean(router.query.modalId)}
        >
            {children(handleOnClick)}
        </Link>
    );
};

export default OpenModal;
